import Controller from "@/objects/controller";
import Cupid from "@/objects/cupid";
import { Assets } from "@/utils/assets";
import { Global } from "@/utils/global";
import { Scenes } from "@/utils/scenes";
import Phaser from "phaser";
import { LevelData } from "@/config/level";
import Life from "@/objects/life";
import Debug from "@/utils/debug";
import { AmmunitionGroup } from "@/objects/ammunition";
import LevelLabel from "@/objects/level";
import ScoreLabel from "@/objects/score";

class Game extends Phaser.Scene{

    private cupid?: Cupid;
    private shootbtn?: Phaser.GameObjects.Image;
    private movebtn?: Phaser.GameObjects.Image;
    private lifespr?: Phaser.GameObjects.Sprite;
    private levellbl?: LevelLabel;
    private scorelbl?: ScoreLabel;

    private badsprgrp?: Phaser.Physics.Arcade.Group;
    private gudsprgrp?: Phaser.Physics.Arcade.Group;
    private ammunitiongrp?: AmmunitionGroup;

    private bgimage?: Phaser.GameObjects.TileSprite;

    private debug?: Debug;

    private curleveldata: any;
    private isfiring: boolean = false;
    private firedtime: number = 0;
    private ammunitionfiredelay: number = 100;
    private dirspeed: number = 0;
    private scrollspeed: number = 2;
    private lifecount: number = 5;
    private pointsearned: number = 0;

    private spriteleft: number = 0;

    private gameend: boolean = false;

    private bgmusic: any;
    private lostsfx: any;


    constructor(){
        super({
            key: Scenes.Game
        });
    }

    //Phaser scene functions
    public init():void{
        /* Init function */
        this.sceneevent();
        this.initvars();
    }

    public preload():void{
        /* Preload function */

    }

    public create():void{
        /* Create function */
        this.createstage();
        this.enableinteractive();
    }

    public update(time:any, delta:any):void{
        /* Update function */
        if(this.debug?.stats)
            this.debug?.stats.begin();

        if(!this.gameend){
            if(this.cupid){
                if(this.cupid.y < Global.SCREEN_H * 0.1 && this.dirspeed < 0 ){
                    this.dirspeed = 0;
                }
                if(this.cupid.y > Global.SCREEN_H * 0.9 && this.dirspeed > 0 ){
                    this.dirspeed = 0;
                }
                this.cupid.x = Global.SCREEN_CX * 0.35;
                this.cupid.y += this.dirspeed;
                //Firing
                if(time > (this.firedtime + this.ammunitionfiredelay)){
                    this.cupidfire();
                    this.firedtime = time;
                }
            }
            if(this.bgimage)
                this.bgimage.tilePositionX += this.scrollspeed;

            if(this.badsprgrp){
                this.badsprgrp.getChildren().forEach((sprite:any)=>{
                    sprite.x -= this.scrollspeed;
                    if(sprite.x < -20){
                        sprite.destroy();
                    }
                });
            }

            if(this.gudsprgrp){
                this.gudsprgrp.getChildren().forEach((sprite:any)=>{
                    sprite.x -= this.scrollspeed;
                    if(sprite.x < -20){
                        sprite.destroy();
                    }
                });
            }

            //Speed variations
            if(this.sys.game.device.os.desktop){
                this.scrollspeed += this.curleveldata.SPEED_INC;
            }else{
                this.scrollspeed += this.curleveldata.SPEED_INC;
            }
        }

        if(this.debug?.stats)
            this.debug?.stats.end();

    }

    //Other functions
    private initvars(): void{
        /* Init Variable*/
        this.curleveldata = null;
        this.isfiring = false;
        this.firedtime = 0;
        this.ammunitionfiredelay = 100;
        this.dirspeed = 0;
        this.scrollspeed = 2;
        //this.lifecount = 5;
        //this.pointsearned = 0;
        this.spriteleft = 0;
        this.gameend = false;
    }

    private createstage(): void{

        //Active input
        this.input.addPointer(4);

        //Level data
        const levelname = 'LEVEL' + Global.LEVEL;

        this.curleveldata = LevelData[ levelname ];

        this.scrollspeed = Math.floor(1920 * this.curleveldata.SPEED);

        this.bgimage = this.add.tileSprite(0, 0, 2200, 1200, Assets[`BG${Global.LEVEL}`].ID).setOrigin(0,1).setScrollFactor(1);
        this.bgimage.setPosition(0, Global.SCREEN_H);

        this.spriteleft = this.curleveldata.SPRITE.BADCOUNT;
        this.badsprgrp = this.physics.add.group({
            removeCallback:(sprite: any)=>{
                this.spriteleft --;
                if(this.spriteleft <= 0 ){
                    this.gamelevelend();
                }
            }
        });
        this.addbadsprite();

        this.gudsprgrp = this.physics.add.group({
            removeCallback:(sprite)=>{
                //
            }
        });
        this.addgudsprite();

        this.ammunitiongrp = new AmmunitionGroup(this);

        this.cupid = new Cupid(this);
        this.cupid.x = Global.SCREEN_CX * 0.35
        this.cupid.y = Global.SCREEN_H * 0.45

        const controller = new Controller();

        let btnsclae = 1.5;
        if(window.phaserGame.device.os.desktop){
            btnsclae = 1.2;
        }
        this.shootbtn = controller.shoot(this).setScrollFactor(0).setScale(btnsclae);
        this.shootbtn.setFrame(`shoot${this.curleveldata.BG}.png`);
        this.shootbtn.setInteractive();
        this.shootbtn.on(Phaser.Input.Events.POINTER_DOWN,(pointer: any, px: any, py: any, event: any)=>{
            this.startfiring();
        });

        this.shootbtn.on(Phaser.Input.Events.POINTER_UP,(pointer: any, px: any, py: any, event: any)=>{
            this.stopfiring();
            event.stopPropagation();
        });

        this.movebtn = controller.move(this).setScrollFactor(0).setScale(btnsclae);
        this.movebtn.setData('touch',false);
        this.movebtn.setInteractive();
        this.movebtn.on(Phaser.Input.Events.POINTER_DOWN,(pointer: any, px: any, py: any, event: any)=>{
            if(this.movebtn){
                this.movebtn.setData('touch',true);
                if(pointer.downY > (this.movebtn.y - this.movebtn.displayHeight * 0.5)){
                    this.movecupiddown();
                }else{
                    this.movecupidup();
                }
            }
        });
        this.movebtn.on(Phaser.Input.Events.POINTER_MOVE,(pointer: any, px: any, py: any, event: any)=>{
            if(this.movebtn){
                if(this.movebtn.getData('touch') === true){
                    if(pointer.y > (this.movebtn.y - this.movebtn.displayHeight * 0.5)){
                        this.movecupiddown();
                    }else{
                        this.movecupidup();
                    }
                }
            }
        });
        this.movebtn.on(Phaser.Input.Events.POINTER_UP,(pointer: any, px: any, py: any, event: any)=>{
            if(this.movebtn){
                this.movebtn.setData('touch',false);
            }
            this.stopcupidmove();
            event.stopPropagation();
        });

        if(window.phaserGame.device.os.desktop){
            //
        }else{
            if(this.movebtn){
                this.movebtn.scaleX = this.movebtn.scaleX * 0.9;
                this.movebtn.scaleY = this.movebtn.scaleY * 0.9;
            }
            if(this.shootbtn){
                this.shootbtn.scaleX = this.shootbtn.scaleX * 0.9;
                this.shootbtn.scaleY = this.shootbtn.scaleY * 0.9;
            }
        }

        this.lifespr = new Life(this).setScrollFactor(0).setOrigin(0,0.5);
        this.lifespr.setPosition(Global.SCREEN_W * 0.08, Global.SCREEN_H * 0.08);

        this.levellbl = new LevelLabel(this).setScrollFactor(0).setOrigin(1,0.5);
        this.levellbl.setPosition(Global.SCREEN_W * 0.88, Global.SCREEN_H * 0.08);
        this.levellbl.update(Global.LEVEL);

        this.scorelbl = new ScoreLabel(this).setScrollFactor(0).setOrigin(0,0.5);
        this.scorelbl.setPosition(Global.SCREEN_W * 0.048, Global.SCREEN_H * 0.14);
        
        //Update values
        this.ammunitionfiredelay = this.cupid.displayWidth * 0.40;

        this.physics.add.overlap(
            this.cupid,
            this.badsprgrp,
            this.collidebadsprite,
            undefined,
            this
        );
        
        this.physics.add.overlap(
            this.ammunitiongrp,
            this.badsprgrp,
            this.shootbadsprite,
            undefined,
            this
        );

        this.physics.add.overlap(
            this.cupid,
            this.gudsprgrp,
            this.collidegudsprite,
            undefined,
            this
        );
        
        this.physics.add.overlap(
            this.ammunitiongrp,
            this.gudsprgrp,
            this.shootgudsprite,
            undefined,
            this
        );

        this.updatescorepoint();
        this.updatelife();

        //Sound
        this.bgmusic = this.sound.add('bgmusic',{
            volume: 0.5, loop: true
        });
        this.bgmusic.play();
        /*
        this.lostsfx = this.sound.add('lost',{
            volume: 0.7,
        });
        */

        //
        this.initresize();

        //Debug
        this.debug = new Debug(this, false);

    }

    private enableinteractive(): void{

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.input.keyboard.on('keydown',(event: any)=>{
            switch((event.key).toLowerCase()){
                case 'a':
                    this.movecupidup();
                break;
                case 'z':
                    this.movecupiddown();
                break;
                case '.':
                    this.startfiring();
                break;
            }
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.input.keyboard.on('keyup',(event: any)=>{
            switch((event.key).toLowerCase()){
                case 'a':
                    this.stopcupidmove();
                break;
                case 'z':
                    this.stopcupidmove();
                break;
                case '.':
                    this.stopfiring();
                break;
            }
        });

    }

    private movecupiddown(): void{
        this.dirspeed = 5;
    }

    private movecupidup(): void{
        this.dirspeed = -5;
    }

    private stopcupidmove(): void{
        this.dirspeed = 0;
    }

    private startfiring(): void{
        this.isfiring = true;
    }

    private stopfiring(): void{
        this.isfiring = false;
        this.firedtime = 0;
    }

    private updatescorepoint(): void{
        this.scorelbl?.update(this.pointsearned.toString());
    }

    private updatelife(): void{
        this.lifespr?.update(this.lifecount);
    }

    private cupidfire(): void{
        if(this.isfiring && this.cupid){
            this.ammunitiongrp?.shoot(
                this.cupid.x + this.cupid.displayWidth * 0.5,
                this.cupid.y
            )
        }
    }

    //Add sprites
    addbadsprite(): void{
        //@typescript-eslint/no-empty-function
        let xpos = Global.SCREEN_W * 2
        for(let i=0; i<this.curleveldata.SPRITE.BADCOUNT; i++){
            const badname = this.curleveldata.SPRITE.BAD;
            badname.sort(() => Math.random() - 0.5);
            const sprite = this.physics.add.sprite(0, 0, 'game', badname[0] + '.png').setImmovable(true);
            sprite.setPosition(xpos, Phaser.Math.Between(Global.SCREEN_H * 0.1,Global.SCREEN_H * 0.9));
            this.badsprgrp?.add(sprite);
            if(this.bgimage)
                xpos += this.bgimage.width * 0.5
        }
    }

    addgudsprite(): void{
        //@typescript-eslint/no-empty-function
        let xpos = Global.SCREEN_W * 3
        for(let i=0; i<this.curleveldata.SPRITE.GOODCOUNT; i++){
            const gudname = this.curleveldata.SPRITE.GOOD;
            gudname.sort(() => Math.random() - 0.5);
            const sprite = this.physics.add.sprite(0, 0, 'game', gudname[0]+'.png').setImmovable(true);
            sprite.setPosition(xpos, Phaser.Math.Between(Global.SCREEN_H * 0.1,Global.SCREEN_H * 0.9))
            this.gudsprgrp?.add(sprite);
            if(this.bgimage)
                xpos += this.bgimage.width * 2
        }
    }

    //Collision
    collidebadsprite(object1: any, object2: any): void{
        //@typescript-eslint/no-empty-function
        if(object2.visible){
            object2.setVisible(false);
            object2.setActive(false);
            object2.destroy(true);
            //Life
            this.lifecount --;
            //this.lostsfx.play();
            if(this.lifecount <= 0){
                this.lifecount = 0;
                this.ongameend(false);
            }else{
                if(this.spriteleft >= 1){
                    //this.showpopup(object2.frame.name);
                }
            }
            this.updatelife();
        }
    }

    collidegudsprite(object1: any, object2: any): void{
        //@typescript-eslint/no-empty-function
        if(object2.visible){
            object2.setVisible(false);
            object2.setActive(false);
            object2.destroy(true);
        }
    }

    shootbadsprite(object1: any, object2: any): void{
        //@typescript-eslint/no-empty-function
        if(object2.visible && object1.visible){
            if(object2.x < Global.SCREEN_W){
                //Obj1
                object1.setVisible(false);
                object1.setActive(false);
                //Obj2
                object2.setVisible(false);
                object2.setActive(false);
                object2.destroy(true);
                //Points
                this.pointsearned ++;
                window.pointsEarned = this.pointsearned;
                this.updatescorepoint();
            }
        }
    }

    shootgudsprite(object1: any, object2: any): void{
        //@typescript-eslint/no-empty-function
        if(object2.visible && object1.visible){
            if(object2.x < Global.SCREEN_W){
                //Obj1
                object1.setVisible(false);
                object1.setActive(false);
                //Obj2
                object2.setVisible(false);
                object2.setActive(false);
                object2.destroy(true);
                //Life
                this.lifecount ++;
                if(this.lifecount >= 5){
                    this.lifecount = 5
                }
                this.updatelife();
            }
        }
    }

    //Show popup
    private showpopup(name: string): void{
        window.pauseGame();
        switch(name){
            case 'enemy1.png':
                window.showOrHideInstructionPopup2(true);
            break;

            case 'enemy2.png':
                window.showOrHideInstructionPopup3(true);
            break;

            case 'enemy3.png':
                window.showOrHideInstructionPopup4(true);
            break;

            case 'enemy4.png':
                window.showOrHideInstructionPopup5(true);
            break;

            case 'enemy5.png':
                window.showOrHideInstructionPopup2(true);
            break;

            case 'boss.png':
                window.showOrHideInstructionPopup5(true);
            break;

            case 'good1.png':
                window.showOrHideInstructionPopup4(true);
            break;

            case 'good2.png':
                window.showOrHideInstructionPopup5(true);
            break;
        }
    }

    //Game End
    private ongameend(life: boolean): void{
        this.gameend = true;
        window.showOrHideRegisterPopup(true, life);
    }

    private gamelevelend(): void{
        //@typescript-eslint/no-empty-function
        if(this.lifecount >= 0){
            this.gameend = true;
            if(Global.LEVEL > 4){
                window.showOrHideRegisterPopup(true, false);
            }else{
                window.showOrHideLevelUpPopup(true);
            }
        }
    }

    //Resize event
    private initresize(): void{

        this.scale.on('resize',(gameSize: any, baseSize: any, displaySize: any, resolution: any)=>{
            this.cameras.resize(gameSize.width, gameSize.height);
            this.resize();
        });
        this.resize();

    }

    private resize(): void{

        let xMax = 0, yMax = 0, xMin = 0, yMin = 0;

        if(this.bgimage){
            this.bgimage.scaleX = Math.max(1, (Global.SCREEN_W/this.bgimage.displayWidth));
            //this.bgimage.scaleY = Math.max(1, (Global.SCREEN_H/this.bgimage.displayHeight));
            this.bgimage.setPosition(0, Global.SCREEN_H);
        }

        this.cupid?.setPosition(Global.SCREEN_CX * 0.35, Global.SCREEN_H * 0.45);

        if(this.bgimage){
            xMax = Math.min(Global.SCREEN_W, (this.bgimage.x + this.bgimage.displayWidth));
            yMax = Math.min(Global.SCREEN_H, (this.bgimage.y + this.bgimage.displayHeight));
            xMin = Math.max(0, (this.bgimage.x - this.bgimage.displayWidth));
            yMin = Math.max(0, (this.bgimage.y - this.bgimage.displayHeight));
        }

        if(this.shootbtn){
            this.shootbtn.x = xMax - 60;
            this.shootbtn.y = yMax - 45;
        }

        if(this.movebtn){
            this.movebtn.x = xMin + 60;
            this.movebtn.y = yMax - 45;
        }

        if(this.lifespr){
            this.lifespr.x = xMin + 60;
            this.lifespr.y = yMin + 60;
        }

        if(this.scorelbl){
            this.scorelbl.x = xMin + 95;
            this.scorelbl.y = yMin + 125;
        }

        if(this.levellbl){
            this.levellbl.x = xMax - 60;
            this.levellbl.y = yMin + 60;
        }

    }

    //Scene Events
    private sceneclear(): void{
        /* Scene Clear */
        this.time.removeAllEvents();
        this.bgmusic.stop();
    }

    private scenepause(): void{
        /* Scene Pause */
        if(this.movebtn)
            this.movebtn.setData('touch',false);
        this.stopfiring();
        this.stopcupidmove();
        this.sound.pauseAll();
    }

    private sceneresume(): void{
        /* Scene Resume */
        this.sound.resumeAll();
    }

    private sceneevent(): void{

        this.events.on(Phaser.Scenes.Events.SHUTDOWN, ()=>{
            this.sceneclear();
        });

        this.events.on(Phaser.Scenes.Events.PAUSE, ()=>{
            this.scenepause();
        });

        this.events.on(Phaser.Scenes.Events.RESUME, ()=>{
            this.sceneresume();
        });

    }

}

export { Game }
